import { useTranslation } from 'react-i18next';
import { Backdrop, Box, Button, CircularProgress } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { useState } from 'react';
import { Drawer, Form } from 'antd';
import SweetAlert from "sweetalert2"
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import SearchInput from '../../SearchInput';
import Utilisateur from '../../../Models/Utilisateur';
import CheckboxF from '../../ChexBox';
import Data from '../../../Data/Data.json'
import ClientInterne from '../ClientInterne/ClientInterne';
import Client from '../../../Models/Client';
import { Crypter } from '../../../Functions/Security/Crypter';
import axios from 'axios';


// import { useState } from 'react';
// import DataSelect from '../../../Types/DataSelect';
// const Swal = require('sweetalert2');

//import linkt = React.lazy(() => import('./questions'));
// let Link = require('../../../Data/Data.json');

//Initialisation des parametres de recherche

const Tab1 = (props: { etatG?: boolean, form?: any, Function1?: any, Function2?: any }) => {

  //const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  // const [CatCpte, SetCatCompte] = useState<DataSelect[]>([]);
  // const [typcpte, Settypcpte] = useState('Z');
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const authHeader = useAuthHeader();


  //CPTCRE 
  let searchNumCompte: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "AGCCPT", colfiltre: "TYPCPT", valfiltre: 'I', Choix: 22 }
  let searchTypeCompte: ParamsPicklist = { CodeAgence: "I", Table: "TYPCPT", Colonne1: "CODTYP", Colonne2: "LIBELLE", Colagence: "CODTYP", Choix: 22 }
  let searchDevise: ParamsPicklist = { CodeAgence: "", Table: "DEVISE", Colonne1: "CODDEV", Colonne2: "LIBELL", Colagence: "101", Choix: 22 }
  let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }
  let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', colfiltre: 'TYPCLI', valfiltre: 'I', Choix: 22 }
  let searchPlanComptable: ParamsPicklist = { CodeAgence: "I", Table: "plancp", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "categocpt", Choix: 39,tablelength:'societe',collength:'LenPlancp' }
  let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
  let searchCptArmortissement: ParamsPicklist = { CodeAgence: 'I', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'TYPCPT', Choix: 22 }
  let searchCptRapprochement: ParamsPicklist = { CodeAgence: '', Table: "CORDREPERM", Colonne1: "CPTCRE", Colonne2: "LIBCPTDEB", Colagence: '101', Choix: 22 }

  //information du client
  //
  let informationclient = {
    searchNumeroCompte: {
      Titre: "Recherche Numéro de Compte",
      label: "Numéro Compte",
      name: "NUMCPT", params: searchNumCompte
    },
    searchTypeCompte: {
      Titre: "Recherche Type de Compte",
      label: "Type compte",
      name: "TYPCPT", params: searchTypeCompte
    },
    searchDevise: {
      Titre: "Recherche Dévise",
      label: "Dévise",
      name: "CDDEVS", params: searchDevise
    },
    searchAgence: {
      Titre: "Recherche Agence",
      label: "Agence",
      name: "AGCCPT", params: searchAgence
    },
    SearchClient: {
      Titre: " Recherche Indice Client",
      label: "Indice interne",
      name: "NUMCLI", params: searchClient
    },
    Inputcle: {
      label: "Cle",
      name: "CLECLI"
    },
    searchPlanComptable: {
      Titre: "Recherche Plan Comptable",
      label: "Plan comptable",
      name: "IDPLAN", params: searchPlanComptable
    },
    //--audit
    InputNom: {
      label: "Nom du compte",
      name: "NOMCPT"
    },
    //--audit
    SearchGestionnaire: {
      Titre: "Recherche Gestionnaire",
      label: "Gestionnaire",
      name: "CDGESTCLI", params: searchGestionnaire

    },
    SearchCompteArmond: {
      Titre: "Armond",
      label: "compte d\'Amortissement",
      name: "cdarmont", params: searchCptArmortissement

    },
    SearchCompteRapro: {
      Titre: "CODRAPP",
      label: 'Rapprochement',
      name: "CODRAPP", params: searchCptRapprochement

    },
    SearchAnalyt: {
      Titre: "Recherche Analytique",
      label: 'Analytique',
      name: "ANALYT", params: searchCptRapprochement
    },

    InputInstitule: {
      label: "Intitulé du Client",
      name: "NOMCLI"
    }
  }



  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  const onFinish = (values: any) => {
    var Client: Client = values;
    Client.TYPCLI = "I";
    Client.UTILIS = user.coduti;
    Client.CODAGE = user.codage;


    // Client.DateDelcni = Client.DateDelcni? (new Date(Client.DateDelcni)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00" : ""
    // Client.DATNAI = (new Date(Client.DATNAI)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00"

    Client.DATCRE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');

    if (Client.NUMCLI.length !== 0) {
      SweetAlert.fire({
        title: "Enregistrement du client",
        text: "Voulez-vous enregistrer le client  " + Client.NOMCLI + " ?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);

          //let group = profilsDistant.find(()=>)
          console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Client)));

          let data = Crypter.encrypt(JSON.stringify(Client));

          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateNewCLIENT,
            headers: {
              // 'CypherClient': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data));

                if (res.StatutCode == 200) {

                  localStorage.clear()

                  form.resetFields();
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });

                }
                else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });

        }
      })
    } else {
      SweetAlert.fire({ title: "Saisie Invalide", text: "le numéro de client doit étres sur 7 carréteres", icon: "error" })
    }
  }

  return (
    <div className='tabItem' >
      <Drawer className='Drawer' title="Nouveau client interne" size='large' onClose={onClose} open={open}>
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <SearchInput notremove width={7} Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} form={props.form} />
          <InputForm width={7} label={informationclient.InputInstitule.label} name={informationclient.InputInstitule.name} type='text' />

          <Box sx={{ display: 'flex' }} gap={2}>
            <Button type='submit' color='success' variant="outlined">Enregistrer </Button>
            <Button type='reset' color='warning' variant="outlined">Annuler</Button>
          </Box>

        </Form>
      </Drawer>
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        <legend >Information comptes </legend>
        <Box style={{ display: 'flex' }}   >
          <Box fontStyle="inherit" width={'50%'} >
            {/* <SearInputM defaultCode="I" defaultLibelle="CPTES COMPTABILITE" width={7} Titre={informationclient.searchTypeCompte.Titre} label={informationclient.searchTypeCompte.label} name={informationclient.searchTypeCompte.name} Parametre={informationclient.searchTypeCompte.params} form={props.form} /> */}
            <SearInputM defaultCode={user.codage} disabled={true} defaultLibelle={user.agence} width={7} Titre={informationclient.searchAgence.Titre} label={informationclient.searchAgence.label} name={informationclient.searchAgence.name} Parametre={informationclient.searchAgence.params} form={props.form} />
             <SearInputM width={7} Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} form={props.form} ExecuteafterSelect2={props.Function2} />

            <SearInputM width={7} Titre={informationclient.searchPlanComptable.Titre} label={informationclient.searchPlanComptable.label} name={informationclient.searchPlanComptable.name} Parametre={informationclient.searchPlanComptable.params} form={props.form} />
          </Box>
          <Box fontStyle="inherit" width={'50%'} >
            <SearInputM width={7} defaultCode="XAF" disabled={true} defaultLibelle="FRANC CFA BEAC" Titre={informationclient.searchDevise.Titre} label={informationclient.searchDevise.label} name={informationclient.searchDevise.name} Parametre={informationclient.searchDevise.params} form={props.form} />
            <InputForm width={7} label={informationclient.InputNom.label} name={informationclient.InputNom.name} type='text' error='ce Champ est obligatoire' />
           <CheckboxF CheCkDefauld name='AplAgc' label='Appliquer aux agences' />
          <Box>
         </Box>
              
            {/* <SearInputM width={7} Titre={informationclient.SearchGestionnaire.Titre} label={informationclient.SearchGestionnaire.label} name={informationclient.SearchGestionnaire.name} Parametre={informationclient.SearchGestionnaire.params} form={props.form} /> */}
         </Box>
        </Box>
        <Box width={'100%'}>
                <SearchInput dissabledCode={props.etatG} notRequired width={3} Titre={informationclient.searchNumeroCompte.Titre} label={informationclient.searchNumeroCompte.label} name={informationclient.searchNumeroCompte.name} Parametre={informationclient.searchNumeroCompte.params} form={props.form} />
         </Box>
         
      </Box>
      
{/* 
      <Box marginTop={'-7%'} display={"flex"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
        <InputForm notRequired disabled taille={200} width={10} label='UTILISATEUR  CREER' name='UTILIS' defaultValue='' type='text' error='mobile' />
        <InputForm notRequired disabled taille={200} width={10} label='DATE CREATION' name='DATCRE' defaultValue='' type='text' error='mobile' />
      </Box> */}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="success" />
      </Backdrop>


    </div>
  );
}

export default Tab1;